enum Brands {
    MOSH = 'mosh',
    MOSHY = 'moshy',
}

export default Brands;
